import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FilterProvider } from "@/context/FilterContext";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import AiPanel from "@/components/AiPanel";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ManagerDashboard from "@/pages/ManagerDashboard";
import GoalSetting from "@/pages/GoalSetting";
import PR from "@/pages/PR";
import SocialMedia from "@/pages/SocialMedia";
import Influencer from "@/pages/Influencer";
import VideoProduction from "@/pages/VideoProduction";
import VideoEditing from "@/pages/VideoEditing";
import SEO from "@/pages/SEO";
import ContentWriting from "@/pages/ContentWriting";
import GraphicDesign from "@/pages/GraphicDesign";
import ContentPipeline from "@/pages/ContentPipeline";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import { Activity } from "lucide-react";

function Shell() {
  const { user, loading } = useAuth();
  const [aiOpen, setAiOpen] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy">
        <Activity className="w-10 h-10 text-gold animate-pulse" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <Layout onAskAi={() => setAiOpen(true)}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/manager" element={<ManagerDashboard />} />
        <Route path="/goals" element={<GoalSetting />} />
        <Route path="/pr" element={<PR />} />
        <Route path="/social" element={<SocialMedia />} />
        <Route path="/seo" element={<SEO />} />
        <Route path="/influencer" element={<Influencer />} />
        <Route path="/video" element={<VideoProduction />} />
        <Route path="/video-editing" element={<VideoEditing />} />
        <Route path="/writing" element={<ContentWriting />} />
        <Route path="/design" element={<GraphicDesign />} />
        <Route path="/pipeline" element={<ContentPipeline />} />
        <Route path="/team" element={<Team />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <AiPanel open={aiOpen} setOpen={setAiOpen} />
    </Layout>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={<Shell />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <FilterProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </FilterProvider>
      </AuthProvider>
      <Toaster position="top-right" richColors theme="dark" />
    </div>
  );
}

export default App;
